import firebase from "./src/firebase";

export default firebase;
